import { render } from "./SessionDetails.vue?vue&type=template&id=7172106a"
import script from "./SessionDetails.vue?vue&type=script&lang=js"
export * from "./SessionDetails.vue?vue&type=script&lang=js"

import "./SessionDetails.vue?vue&type=style&index=0&id=7172106a&lang=css"

import exportComponent from "/home/forge/virtualcp.app/releases/20250710180701/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__